<template>
    <div class="">
        <Form ref="trophyForm" :model="trophyForm" :rules="trophyRules">
            <FormItem prop="TrophyName">
                <div style="position: relative">
                    <i-input
                            v-model="trophyForm.TrophyName"
                            type="text"
                            placeholder="Trophy Name"
                    ></i-input>
                    <Button style="position: absolute;right: -80px;" type="primary" @click="resetData" v-if="showReset" ghost>Reset</Button>
                </div>
            </FormItem>
        </Form>
        <Row type="flex" justify="center" :gutter="16" style="margin-top: 24px;">
            <i-col :xs="12" v-if="showUpdate">
                <Button long
                        type="success"
                        :loading="submitUpdateLoading"
                        @click="handleCreateOrUpdate('update')"
                >       <span v-if="!submitUpdateLoading">Update Trophy</span>
                    <span v-else>Processing...</span>
                </Button>
            </i-col>
            <i-col :xs="12">
                <Button long
                        type="primary"
                        :loading="submitLoading"
                        @click="handleCreateOrUpdate('create')"
                >       <span v-if="!submitLoading">Add Trophy</span>
                    <span v-else>Processing...</span>
                </Button>
            </i-col>
        </Row>
        <Spin size="large" fix v-if="spinShow">
            <Icon type="ios-loading" size=32 class="spin-icon-load"></Icon>
        </Spin>
    </div>

</template>

<script>
    import { bus } from "../../main";
    import { getTrophy, addTrophy, updateTrophy } from "../../_services/trophy.service";

    export default {
        props:['Trophies'],
        data() {
            const validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please fill in the tournament name.'));
                } else {
                    let duplicateName=this.Trophies.filter(({TrophyName})=>{
                        return TrophyName===value
                    })
                    if(duplicateName.length){
                        if(this.trophyForm._id){
                            if(duplicateName.length>1){
                                callback(new Error('Trophy name already exist.'));
                            }else{
                                if(duplicateName[0]._id!==this.trophyForm._id){
                                    callback(new Error('Trophy name already exist.'));
                                }else{
                                    callback();
                                }
                            }
                        }else{
                            callback(new Error('Trophy name already exist.'));
                        }
                    }else{
                        callback();
                    }
                }
            };
            return {
                submitUpdateLoading:false,
                submitLoading:false,
                showUpdate:false,
                trophyForm: {
                    TrophyName: ""
                },
                currentUpdateData:{
                    TrophyName: ""
                },
                trophyRules: {
                    TrophyName: [
                        { validator: validateName, trigger: 'blur' }
                    ]
                },
                spinShow:false,
            };
        },
        computed:{
            showReset(){
                if(this.currentUpdateData._id){
                    if(this.currentUpdateData.TrophyName!==this.trophyForm.TrophyName) {
                        return true
                    }else {
                        return false
                    }
                }else {
                    return false
                }
            }
        },
        methods: {
            setUpdateData(data){
                let vm=this
                vm.spinShow=true
                if(this.currentUpdateData._id){
                    vm.spinShow=false
                    if(this.currentUpdateData.TrophyName!==this.trophyForm.TrophyName){
                        this.$Modal.confirm({
                            title: 'Unsaved Changes',
                            content: `Changes made on ${this.currentUpdateData.TrophyName} is not yet saved? Do you wish to save it first?`,
                            okText: 'Save',
                            cancelText: 'Discard',
                            onOk: () => {
                                this.handleCreateOrUpdate('update',data)
                            },
                            onCancel: () =>{
                                this.getTrophyData(data)
                                this.$emit('setActive',data)
                            }
                        });
                    }else{
                        this.getTrophyData(data)
                        this.$emit('setActive',data)
                    }
                }else {
                    this.getTrophyData(data)
                    this.$emit('setActive',data)
                }
            },
            getTrophyData(data){
                let vm=this
                vm.resetForm()

                getTrophy(data._id).then(async res=>{
                    this.showUpdate=true
                    vm.trophyForm=res.data.data
                    this.currentUpdateData = Object.assign({},res.data.data)
                    vm.spinShow=false
                }).catch(err=>{
                    vm.spinShow=false
                })
            },
            resetForm(){
                this.showUpdate=false
                this.currentUpdateData={}
                this.trophyForm={
                    TrophyName: "",
                    Description: {},
                    Trophies: []
                }
                this.$refs.trophyForm.resetFields();
            },
            resetData(){
                this.trophyForm.TrophyName=this.currentUpdateData.TrophyName
            },
            handleCreateOrUpdate(method,nexData) {
                if(method==='create' && this.trophyForm._id) {
                    this.showUpdate=false
                    delete this.trophyForm._id;
                    this.$emit('setActive',null);
                }
                this.$refs.trophyForm.validate(valid => {
                    if (valid) {
                        if(method==='create') {
                            this.submitLoading=true
                            addTrophy(this.trophyForm).then(res => {
                                this.$Message.success(`${this.trophyForm.TournamentName} added to trophies!`);
                                this.$emit('getTrophies')
                                this.submitLoading = false
                                this.resetForm()
                            }).catch(err => {
                                bus.$emit('requestError',err)
                                this.submitLoading = false
                                this.$Message.error('Failed to create trophy. Please try again later.')
                            })
                        }else{
                            this.submitUpdateLoading=true
                            updateTrophy(this.trophyForm._id,this.trophyForm).then(res => {
                                this.$Message.success(`Successfully updated trophy ${this.trophyForm.TrophyName}!`);
                                this.$emit('getTrophies')
                                this.submitUpdateLoading = false
                                this.currentUpdateData = Object.assign({},res.data.data)
                                if(nexData){
                                    this.$emit('setActive',nexData);
                                    this.getTrophyData(nexData)
                                }
                            }).catch(err => {
                                bus.$emit('requestError',err)
                                this.submitUpdateLoading = false
                                this.$Message.error('Failed to update trophy. Please try again later.')
                            })
                        }
                    }
                });
            },
        },
        mounted() {
        }
    };
</script>
<style scoped>

</style>
